module.exports = __webpack_public_path__ + "static/img/about-img.04587a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/about-img.png
// module id = uiFB
// module chunks = 2